
















































































































































import { Component, Prop } from "vue-property-decorator";
import { Student } from "../../../src_server/entity/generated/Student";
import { InputPages } from "../../components/organisms/InputPages";
import { schoolYearsOptions } from "../../../src_server/entity/master/schoolYearsData";
import { schoolTypeOptions } from "../../../src_server/entity/master/schoolType";
import ErrorSummary from "../../components/inputs/ErrorSummary.vue";
import { Session } from "../../utils/Session";
import { hope_course } from "../../../src_server/entity/master/hope_course";
@Component({
  components: { ErrorSummary },
})
export default class StudentEducationalEnvPage extends InputPages {
  @Prop()
  value!: Student;
  get hope_course() {
    return hope_course;
  }
  get schoolYeas(): { title: string; value: string }[] {
    return schoolYearsOptions;
  }
  get schoolType() {
    return schoolTypeOptions;
  }

  get hasDeafnessClass(): { title: string; value: string }[] {
    return [
      { title: "あり", value: "あり" },
      { title: "なし", value: "なし" },
    ];
  }

  get isCO() {
    return Session.isCircleOBuilding();
  }

  isDeafnessSchool(school_type: string) {
    return school_type === "聴覚支援学校";
  }

  // get showConsiderationOther(): boolean {
  //   if (!this.model.consideration) {
  //     return false;
  //   }
  //   return this.model.consideration.indexOf("その他 [短文自由記述]") > 0;
  // }
  get model(): Student {
    return this.value;
  }

  set model(value: Student) {
    this.value = value;
  }
}
